<!--
  name : 이예닮
  desc : 사원관리
  date : 2021-07-19
-->
<template>
  <v-container id="set_crew" class="con_mpw">
    <!--현재설정기업-->
    <v-row no-gutters class="row_mt-40 row_mb-40">
      <div class="dot_tt">현재설정기업</div>
      <v-col cols="12" class="set_pic_con">
        <div class="org_pic_cov">
          <div class="org_pic cpn">
            <v-img
              :src="atvOrgInfo.orgImg"
              style="height:100%;text-align: center;"
              v-if="atvOrgInfo.orgImg != ''"
            ></v-img>
          </div>
        </div>
        <div class="org_info_cov">
          <v-row no-gutters>
            <v-col cols="12">
              <ul class="pattern_ulTxtBox">
                <li>
                  <span class="txt_tt03">기업명</span>
                  <span class="txt_txt01 no_pr">{{
                    this.atvOrgInfo.organizationName
                  }}</span>
                  <span class="txt_txt02">
                    ({{
                      this.atvOrgInfo.organizationRegistrationNumber
                        | regNumFilter
                    }})</span
                  >
                </li>
                <li>
                  <span class="txt_tt03">대표자명</span>
                  <span class="txt_txt01 no_pr">{{
                    this.atvOrgInfo.presidentName
                  }}</span>
                </li>
                <li>
                  <span class="txt_tt03">연락처</span>
                  <span class="txt_txt01 no_pr">{{
                    this.atvOrgInfo.organizationContact | formatContact
                  }}</span>
                </li>
              </ul>
            </v-col>
            <v-col cols="12">
              <ul class="pattern_ulTxtBox">
                <li>
                  <span class="txt_tt03">기업 관리자</span>
                  <span class="txt_txt01 no_pr">{{
                    this.adminUsrInfo.userName
                  }}</span>
                  <span class="txt_txt02">
                    ({{ this.adminUsrInfo.userEmail }})</span
                  >
                </li>
                <li>
                  <span class="txt_tt03">전자계약 관리자</span>
                  <span class="txt_txt01 no_pr">{{
                    this.CadminInfo.userName
                  }}</span>
                  <span class="txt_txt02">
                    ({{ this.CadminInfo.userEmail }})</span
                  >
                </li>
              </ul>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>

    <!--User list-->
    <v-row no-gutters class="row_mb-20">
      <div class="dot_tt">사용자 목록</div>
    </v-row>
    <v-row no-gutters class="setCrew_scroll_bar">
      <v-col cols="12">
        <v-row no-gutters class="align-center row_mb-8">
          <v-col cols="6">
            <ul class="pattern_ulTxtBox">
              <li>
                <span class="txt_icon">기업 참여 요청자</span>
                <span class="txt_txt01 no_pr"
                  >{{ this.tmpOrgUserCount }} 명</span
                >
              </li>
            </ul>
          </v-col>
          <v-col cols="6" class="ta_right">
            <v-btn class="btn17_C01" v-if="isAdmin" @click="adminPop = true"
              >계약담당자 관리</v-btn
            >
          </v-col>
        </v-row>

        <v-row no-gutters class="align-center row_mb-20">
          <v-col
            class="officeC_list for_crew"
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <!--리스트-->
            <v-card
              class="officeC_carD"
              v-for="(orgusrlist, index) of orgUsrList"
              :key="index"
            >
              <v-list-item class="carD_box_clB">
                <div class="carD_01">
                  <div class="carD_01_txt">
                    <ul class="pattern_ulTxtBox">
                      <li>
                        <span class="txt_tt">{{
                          orgusrlist.checkOrgAdmin
                        }}</span>
                        <span class="txt_txt01 no_pr">{{
                          orgusrlist.userName
                        }}</span>
                        <span class="txt_txt02">
                          ({{ orgusrlist.userEmail }})</span
                        >
                        <span class="txt_txt02">
                          {{ orgusrlist.userCtr | formatContact }}</span
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="dateBox">
                    <span class="st_txt">{{ orgusrlist.teamName }}</span>
                  </div>
                </div>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>

        <v-row no-gutters class="align-center row_mb-8">
          <v-col cols="12" sm="6" md="6" lg="6">
            <ul class="pattern_ulTxtBox">
              <li>
                <span class="txt_icon">등록한 사원 수</span>
                <span class="txt_txt01 no_pr">{{ this.totalCnt }} 명</span>
              </li>
            </ul>
          </v-col>
          <!-- button -->
          <v-col cols="12" sm="6" md="6" lg="6" class="ta_right">
            <v-btn class="btn17_C01" @click="crewPop01 = true"
              >엑셀 업로드</v-btn
            >
            <v-btn class="btn17_C01" @click="crewPop02 = true">개별 등록</v-btn>
          </v-col>
        </v-row>

        <!--sawon list-->
        <v-row no-gutters class="align-center row_mb-20">
          <v-col cols="12" sm="12" md="12" lg="12">
            <!--user value true-->
            <div v-if="totalCnt" class="align-center departPop_list">
              <v-card
                class="officeC_carD"
                v-for="(sawonlist, index) of sawonList"
                :key="index"
              >
                <v-list-item class="carD_box_clB for_depart">
                  <div class="carD_01">
                    <div class="carD_01_txt">
                      <ul class="pattern_ulTxtBox">
                        <li>
                          <span class="txt_tt">사원</span>
                          <span class="txt_txt01 no_pr">{{
                            sawonlist.sawonName
                          }}</span>
                          <span class="txt_txt02">
                            ({{ sawonlist.sawonEmail }})</span
                          >
                          <span class="txt_txt02">
                            {{ sawonlist.sawonPhone | formatContact }}</span
                          >
                          <span class="txt_txt02">
                            {{ sawonlist.sawonId }}</span
                          >
                        </li>
                      </ul>
                    </div>
                    <div class="dateBox">
                      <span class="st_txt">{{ sawonlist.teamName }}</span>
                    </div>
                  </div>
                  <v-btn
                    class="btnO_C04 del_list"
                    @click="
                      fnSawonDel(sawonlist.sawonGrpIdx, sawonlist.sawonName)
                    "
                    ><span class="icon"></span
                  ></v-btn>
                </v-list-item>
              </v-card>
            </div>

            <!--user value false-->
            <div v-else class="departPop_list">
              <div class="list_no_txt">
                등록된 사원정보가 없습니다.
              </div>
            </div>

            <!--pageing-->
            <v-row no-gutters class="justify-center" v-if="totalCnt">
              <v-pagination
                v-model="page"
                :length="pageing"
                @input="handlePageChange"
                total-visible="7"
                circle
              ></v-pagination>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!--(Popup)계약담당자 관리-->
    <v-dialog
      @keydown.esc="adminPop = false"
      v-model="adminPop"
      max-width="1200px"
      persistent
    >
      <v-card id="popStyle03">
        <!--title-->
        <v-card-title class="title">
          계약담당자 관리
          <v-btn fab class="popBtnClose" @click="adminPop = false"></v-btn>
        </v-card-title>

        <v-card-text>
          <v-row no-gutters class="justify-center popCon">
            <v-col cols="12">
              <div class="dot_tt16">기업참여 요청 대기자</div>
              <!--list value true-->
              <v-row
                v-if="tmpOrgUserCount"
                no-gutters
                class="align-center crew_list row_mb-40"
              >
                <v-col cols="12">
                  <v-card
                    v-for="(tmpOrgUser, index) of tmpOrgUser"
                    :key="index"
                    class="list_carD02_con"
                    @click="test = true"
                  >
                    <v-list-item class="carD_box_chkO">
                      <div class="org_pic_s mr-1">
                        <v-img
                          :src="tmpOrgUserImg[index]"
                          style="height: 100%; border-radius: 15px;"
                        ></v-img>
                      </div>
                      <ul class="list_carD02_ulTxtBox">
                        <li class="txtCon01">
                          <span class="txt_txt01 no_pr">{{
                            tmpOrgUser.userName
                          }}</span>
                          <span class="txt_txt02">
                            {{ tmpOrgUser.userEmail }}</span
                          >
                          <span class="txt_txt_r">
                            {{ tmpOrgUser.userCtr }}</span
                          >
                        </li>
                        <li class="txtCon02">
                          <span class="txt_txt_l">{{
                            tmpOrgUser.teamName
                          }}</span>
                          <span class="txt_txt_r">{{
                            tmpOrgUser.createDate
                          }}</span>
                        </li>
                      </ul>
                      <v-btn
                        text
                        class="btn17_C01"
                        @click="confirmOrgUsr(tmpOrgUser)"
                        >참여승인</v-btn
                      >
                      <v-btn
                        outlined
                        class="btn17_C05"
                        @click="rejectOrgUsr(tmpOrgUser)"
                        >삭제</v-btn
                      >
                    </v-list-item>
                  </v-card>
                </v-col>
              </v-row>
              <!--list value false-->
              <v-row v-else no-gutters class="align-center crew_list row_mb-40">
                <v-col cols="12">
                  <div class="list_no_txt">
                    기업참여 요청 대기자가 없습니다.
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <div class="dot_tt16">계약 담당자 목록</div>
              <!--list-->
              <v-row no-gutters class="align-center crew_list row_mb-20">
                <v-col cols="12">
                  <v-card
                    class="list_carD02_con"
                    v-for="(orgusrlist, index) of orgUsrList"
                    :key="index"
                    @click="test = true"
                  >
                    <v-list-item class="carD_box_delO">
                      <div class="org_pic_s mr-1">
                        <v-img
                          :src="orgUsrImg[index]"
                          style="height: 100%; border-radius: 15px;"
                        ></v-img>
                      </div>
                      <ul class="list_carD02_ulTxtBox">
                        <li class="txtCon01_03_noelip ">
                          <span class="txt_tt">{{
                            orgusrlist.checkOrgAdmin
                          }}</span>
                          <span class="txt_txt01">{{
                            orgusrlist.userName
                          }}</span>
                          <span class="txt_txt02">
                            {{ orgusrlist.userEmail }}</span
                          >
                          <span class="txt_txt02">
                            {{ orgusrlist.userCtr | formatContact }}</span
                          >
                        </li>
                        <li class="txtCon02_03 txta-right">
                          <span class="txt_txt_l">{{
                            orgusrlist.teamName
                          }}</span>
                          <span class="txt_txt_rl">{{
                            orgusrlist.createDate
                          }}</span>
                        </li>
                      </ul>
                    </v-list-item>
                    <v-btn
                      class="btnO_C04 del_list"
                      @click="deleteUsr(orgusrlist)"
                      ><span class="icon"></span
                    ></v-btn>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn text @click="adminPop = false">닫기</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--(Popup)엑셀 업로드-->
    <v-dialog
      @keydown.esc="fnCancel('엑셀 업로드')"
      v-model="crewPop01"
      max-width="1200px"
      persistent
    >
      <v-card id="popStyle03">
        <!--title-->
        <v-card-title class="title">
          엑셀 업로드
          <v-btn fab class="popBtnClose" @click="crewPop01 = false"></v-btn>
        </v-card-title>
        <!--내용-->
        <v-card-text>
          <v-row no-gutters class="popCon">
            <v-col cols="12" class="posiR">
              <div class="popCon_txt">
                등록할 사원 목록을 엑셀 양식에 작성하여 업로드해 주세요.
              </div>
              <div class="txtst_info_red">
                ※ 글로싸인엔터프라이즈 회원에 등록된 사원 정보를 입력해 주세요.
              </div>
              <!-- excelDownload -->
              <v-btn
                class="btn17_C01 posiA_right0top0 posiR-740 ml-0"
                @click="fnExcelDown()"
                >엑셀 양식 다운</v-btn
              >
            </v-col>
            <v-col cols="12" class="row_mt-20">
              <v-file-input
                class="inputH48_01 W100W Hauto"
                label="엑셀 업로드"
                placeholder=" "
                messages="엑셀 파일만 업로드 가능합니다."
                :accept="uploadAccept"
                outlined
                chips
                dense
                @change="readFile"
                v-model="fileList"
                :key="componentKey"
              ></v-file-input>

              <div
                v-if="excelUploadList.length > 0"
                class="align-center departPop_list"
              >
                <v-card
                  class="officeC_carD"
                  v-for="(excelUploadList, index) of excelUploadList"
                  :key="index"
                >
                  <v-list-item class="carD_box_clB for_depart">
                    <ul class="pattern_ulTxtBox">
                      <li>
                        <span class="txt_tt"
                          >[{{ excelUploadList.아이디 }}]</span
                        >
                        <span class="txt_txt02"
                          >{{ excelUploadList.이름 }} ({{
                            excelUploadList.이메일
                          }})</span
                        >
                        <div
                          class="txtst_info_red6 mt-2"
                          v-if="excelUploadList.사유 != '정상'"
                        >
                          {{ excelUploadList.사유 }}
                        </div>
                        <div
                          class="txtst_info_suc6 mt-2"
                          v-if="excelUploadList.사유 == '정상'"
                        >
                          {{ excelUploadList.사유 }}
                        </div>
                      </li>
                    </ul>
                  </v-list-item>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <!--button-->
        <v-card-actions class="justify-center">
          <v-btn text class="btn_C01" @click="fnExcelUpload()">등록</v-btn>
          <v-btn text @click="fnCancel('엑셀 업로드')">닫기</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--(Popup)개별 등록-->
    <v-dialog
      @keydown.esc="crewPop02 = false"
      v-model="crewPop02"
      max-width="1200px"
      persistent
    >
      <v-card id="popStyle03">
        <!--title-->
        <v-card-title class="title">
          개별 등록
          <v-btn fab class="popBtnClose" @click="crewPop02 = false"></v-btn>
        </v-card-title>
        <!--내용-->
        <v-card-text>
          <v-row no-gutters class="justify-center popCon">
            <div class="popCon_txt">
              ※ 글로싸인엔터프라이즈 회원에 등록된 사원 정보를 입력해 주세요.
            </div>
            <v-col cols="12" class="row_mt-20">
              <v-text-field
                ref="emailRules"
                class="inputH48_02"
                label="수신자의 이메일 주소"
                outlined
                dense
                reserve-keyword
                v-model="findCrew"
                :rules="findCrew_rules"
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <!--button-->
        <v-card-actions class="justify-center">
          <v-btn text class="btn_C01" @click="fnInputData()">등록</v-btn>
          <v-btn text @click="fnCancel('개별 등록')">닫기</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <s-loading ref="loading"></s-loading>
    <s-confirm ref="confirm"></s-confirm>
  </v-container>
</template>

<script>
import { isManager, isTokenCheck } from "@/api/login";
import { getUserImgList } from "@/api/userImg";
import {
  getAtvOrgInfo,
  removeOrgReqUser,
  confirmOrgReqUser
} from "@/api/orgconfig";
import {
  getSawonList,
  setSawonDel,
  setSawonPersonInsert,
  setSawonExcelInsert,
  setSawonList
} from "@/api/sawon/sawon";
import { autoHypenPhone } from "@/api/common";
import XLSX from "xlsx";

export default {
  name: "crew",
  components: {},
  filters: {
    formatContact: function(value) {
      if (value) {
        return autoHypenPhone(value);
      }
    },
    regNumFilter: function(value) {
      if (value) {
        return String(value).replace(/(\d{3})(\d{2})(\d{5})/, "$1-$2-$3");
      }
    }
  },
  data() {
    return {
      isAdmin: false,
      adminPop: false, // 계약담당자 관리
      crewPop01: false, // 엑셀 업로드
      crewPop02: false, // 개별 등록
      sawonList: [],
      totalCnt: 0, // 사원 count
      pageing: 0, // Pageing
      page: 0,
      orgUsrList: [], // 계약 담당자 목록
      orgUsrImg: [], // 계약 담당자 이미지
      tmpOrgUser: [], // 기업참여 요청 대기자
      tmpOrgUserImg: [], // 기업참여 요청 대기자 이미지
      adminUsrId: "", // 기업 관리자 ID
      adminUsrInfo: [], // 기업 관리자
      CadminInfo: [], // 전자계약 관리자
      tmpOrgUserCount: 0, // 기업참여 요청 대기자 count
      // 기업정보
      atvOrgInfo: {
        organizationName: "",
        creationDatetimesubstr: "",
        organizationRegistrationNumber: "",
        presidentName: "",
        organizationAddress: "",
        organizationContact: "",
        organizationSequence: "",
        chainAddress: "",
        orgImg: ""
      },
      // page num
      pageParam: {
        page: 0,
        size: 5
      },
      // 계약 담당자
      sendDelUserInfo: {
        tmpOrgSequence: 0,
        tmpUserSequence: 0
      },
      // 기업참여 요청 대기자
      sendTmpUserInfo: {
        tmpOrgSequence: 0,
        tmpUserSequence: 0,
        tmpUserTeamId: 0,
        approvalFlag: false
      },
      // 엑셀 업로드
      successCnt: 0,
      resultCode: "",
      uploadAccept: ".xls, .xlsx,",
      fileList: [], // 엑셀 파일
      excelFile: [],
      excelUploadList: [], // 파싱 후 Upload List
      successUploadList: [],
      // 개별 등록
      findCrew: "",
      findCrew_rules: [
        v =>
          /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i.test(
            v
          ) || "이메일 형식을 확인 해주세요."
      ],
      componentKey: 0
    };
  },
  created() {},
  mounted() {
    this.userid = this.$store.state.user.userid;
    this.getOrgList();
  },
  methods: {
    getOrgList() {
      isTokenCheck(this.$store.state.user).then(response => {
        if (response.rdata.getToken !== null) {
          this.$store.dispatch("updateOrgdata", response.rdata.getToken);
        } else {
          this.$store.dispatch("updateOrgdata", "");
        }
      });
      isManager(this.$store.state.user).then(response => {
        if (response.rdata.rcode === 20000) {
          if (response.rdata.isManager) {
            this.getSawonList(); // 사원 list
            getAtvOrgInfo().then(Response => {
              if (
                Response.rdata !== undefined &&
                Response.rdata.rcode === 20000
              ) {
                this.orgUsrList = [];
                this.tmpOrgUser = [];

                this.isAdmin = Response.rdata.isAdmin; // 관리자 유무
                this.adminUsrId = Response.rdata.adminUsrId; // 기업 관리자 ID
                this.adminUsrInfo = Response.rdata.adminUsrInfo; // 기업 관리자
                this.CadminInfo = Response.rdata.CadminInfo; // 전자계약 관리자
                this.tmpOrgUserCount = Response.rdata.tmpOrgUserCount; // 기업 참여 요청자 count

                // 기업정보 입력
                this.atvOrgInfo.organizationName =
                  Response.rdata.atvOrgInfo.organizationName;
                this.atvOrgInfo.creationDatetimesubstr =
                  Response.rdata.atvOrgInfo.creationDatetimesubstr;
                this.atvOrgInfo.organizationRegistrationNumber =
                  Response.rdata.atvOrgInfo.organizationRegistrationNumber;
                this.atvOrgInfo.presidentName =
                  Response.rdata.atvOrgInfo.presidentName;
                this.atvOrgInfo.organizationAddress =
                  Response.rdata.atvOrgInfo.organizationAddress;
                this.atvOrgInfo.organizationContact =
                  Response.rdata.atvOrgInfo.organizationContact;
                this.atvOrgInfo.organizationSequence =
                  Response.rdata.atvOrgInfo.organizationSequence;
                this.atvOrgInfo.chainAddress =
                  Response.rdata.atvOrgInfo.chainAddress;

                if (
                  Response.rdata.CadminInfo.userId === this.userid ||
                  Response.rdata.adminUsrInfo.userId === this.userid
                ) {
                  this.isAdmin = true;
                } else {
                  this.isAdmin = false;
                }

                // 계약 담당자
                for (var k in Response.rdata.orgUserlist) {
                  var checkOrgAdmin = "";
                  if (Response.rdata.imgList[k] != null) {
                    this.orgUsrImg.push(
                      process.env.VUE_APP_URL_USER_THUMBNAIL +
                        Response.rdata.imgList[k].imgSequence
                    );
                  }
                  if (
                    Response.rdata.adminUsrInfo.userId ===
                    Response.rdata.orgUserlist[k].userId
                  ) {
                    checkOrgAdmin = "기업 관리자";
                  } else if (
                    Response.rdata.CadminInfo.userId ===
                    Response.rdata.orgUserlist[k].userId
                  ) {
                    checkOrgAdmin = "전자계약 관리자";
                  } else {
                    checkOrgAdmin = "계약 담당자";
                  }

                  this.orgUsrList.push({
                    id: Response.rdata.orgUserlist[k].id,
                    userAddress: Response.rdata.orgUserlist[k].userAddress,
                    userCtr: Response.rdata.orgUserlist[k].userCtr,
                    userEmail: Response.rdata.orgUserlist[k].userEmail,
                    userId: Response.rdata.orgUserlist[k].userId,
                    userName: Response.rdata.orgUserlist[k].userName,
                    createDate: Response.rdata.orgUserlist[k].createDate,
                    teamName: Response.rdata.orgUserPartInfolist[k],
                    checkOrgAdmin: checkOrgAdmin
                  });
                }

                // 기업참여 요청 대기자
                for (var x in Response.rdata.tmpOrgUser) {
                  getUserImgList(
                    JSON.stringify({
                      chainAddress: Response.rdata.tmpOrgUser[x].chainAddress
                    })
                  ).then(response => {
                    if (response.rdata.userImg) {
                      this.tmpOrgUserImg.push(
                        process.env.VUE_APP_URL_USER_THUMBNAIL +
                          response.rdata.userImg.imgSequence
                      );
                    } else {
                      this.tmpOrgUserImg.push("");
                    }
                  });
                  this.tmpOrgUser.push({
                    userId: Response.rdata.tmpOrgUser[x].userId,
                    userName: Response.rdata.tmpOrgUser[x].userName,
                    userCtr: Response.rdata.tmpOrgUser[x].userCtr,
                    userEmail: Response.rdata.tmpOrgUser[x].userEmail,
                    id: Response.rdata.tmpOrgUser[x].id,
                    createDate: Response.rdata.tmpOrgUser[x].createDate,
                    teamName: "",
                    teamId: ""
                  });
                }
                this.tmpOrgUser.reverse();
                this.getUserImgList();
              } else {
                this.isAdmin = "";
              }
            });
          } else {
            this.isAdmin = "";
            this.$refs.confirm
              .open("alert", "사원관리", "기업회원만 이용 가능합니다.")
              .then(() => {
                this.$router.push("main");
              });
          }
        }
      });
    },
    getUserImgList() {
      getUserImgList(
        JSON.stringify({ chainAddress: this.atvOrgInfo.chainAddress })
      ).then(response => {
        if (response.rdata.userImg) {
          this.atvOrgInfo.orgImg =
            process.env.VUE_APP_URL_USER_THUMBNAIL +
            response.rdata.userImg.imgSequence;
        } else {
          this.atvOrgInfo.orgImg = "";
        }
      });
    },
    getSawonList() {
      getSawonList({ pageParams: this.pageParam }).then(response => {
        if (response.rcode === 20000) {
          this.sawonList = response.rdata.sawonList;
          this.totalCnt = response.rdata.totalCnt;
          if (response.rdata.totalCnt) {
            this.pageing = Math.ceil(this.totalCnt / 5);
          }
        }
      });
    },
    handlePageChange(value) {
      this.pageParam.page = value - 1;
      this.getSawonList();
    },

    // 선택한 사원 삭제 함수
    fnSawonDel(seq, Name) {
      isManager(this.$store.state.user).then(response => {
        if (response.rdata.rcode === 20000) {
          if (response.rdata.isManager) {
            this.$refs.confirm
              .open(
                "confirm",
                "사원삭제",
                "선택하신 " + Name + "을 삭제 하시겠습니까?"
              )
              .then(() => {
                this.$refs.loading.start("입력 정보 확인 중");
                setSawonDel({ sawonSeq: seq }).then(response => {
                  if (response.rdata.resultCode === "20000") {
                    this.$refs.loading.end();
                    this.$refs.confirm.open(
                      "alert",
                      "사원삭제",
                      "삭제가 완료 되었습니다"
                    );
                    this.getSawonList();
                  } else {
                    this.$refs.loading.end();
                    this.$refs.confirm.open(
                      "alert",
                      "사원삭제",
                      "다시 시도해주시기 바랍니다"
                    );
                  }
                });
              })
              .catch(e => {});
          } else {
            this.$refs.confirm.open(
              "alert",
              "사원삭제",
              "기업 회원 전용 메뉴 입니다. 기업정보를 확인하세요."
            );
            this.$router.push({ name: "setting" });
          }
        }
      });
    },

    // 개별 등록
    fnInputData() {
      if (
        this.findCrew === undefined ||
        this.findCrew === null ||
        this.findCrew === ""
      ) {
        this.$refs.confirm.open(
          "alert",
          "개별 등록",
          "등록할 사원의 이메일을 입력해 주세요"
        );
      } else {
        if (this.$refs.emailRules.validate()) {
          this.$refs.loading.start("입력 정보 확인 중");
          setSawonPersonInsert({ sawonFind: this.findCrew })
            .then(response => {
              this.$refs.loading.end();
              if (
                response.rdata.resultCode === "99998" ||
                response.rdata.resultCode === "99997"
              ) {
                this.$refs.confirm.open(
                  "alert",
                  "개별 등록",
                  response.rdata.resultError
                );
              } else if (
                response.rdata.resultCode === "99999" ||
                response.rcode !== 20000
              ) {
                this.$refs.confirm.open(
                  "alert",
                  "개별 등록",
                  "사원 등록에 실페하였습니다. 재등록 해주시기 바랍니다."
                );
              } else {
                this.$refs.confirm.open(
                  "alert",
                  "개별 등록",
                  "사원 등록이 완료 되었습니다"
                );
                this.crewPop02 = false;
                this.getSawonList();
              }
            })
            .catch(() => {
              this.$refs.confirm.open(
                "alert",
                "개별 등록",
                "사원 등록중 에러가 발생 하였습니다 재등록 해주시기 바랍니다"
              );
            });
          this.findCrew = "";
        } else {
          this.$refs.confirm.open(
            "alert",
            "개별 등록",
            "이메일 형식을 확인 해주세요."
          );
        }
      }
    },

    // 기업참여 요청 대기자 승인
    confirmOrgUsr(tmpOrgUser) {
      this.$refs.confirm
        .open(
          "confirm",
          "기업참여 요청 대기자",
          tmpOrgUser.userName + "님의 요청을 승인 하시겠습니까?"
        )
        .then(() => {
          this.sendTmpUserInfo.tmpUserSequence = tmpOrgUser.id;
          this.sendTmpUserInfo.tmpOrgSequence = this.atvOrgInfo.organizationSequence;
          this.sendTmpUserInfo.approvalFlag = true;

          this.$refs.loading.start("입력 정보 확인 중");
          confirmOrgReqUser(this.sendTmpUserInfo).then(Response => {
            if (Response.rdata !== undefined && Response.rcode === 20000) {
              this.$refs.loading.end();
              this.$refs.confirm.open(
                "alert",
                "기업참여 요청 대기자",
                "기업 참여 요청 승인을 완료하였습니다"
              );
              this.getOrgList();
            } else {
              this.$refs.loading.end();
              var msg = "";
              if (Response.rdata === undefined) {
                msg = Response.message;
              } else {
                msg = Response.rdata.message;
              }
              this.$refs.confirm.open("alert", "기업참여 요청 대기자", msg);
            }
          });
        });
    },

    // 기업참여 요청 대기자 거부
    rejectOrgUsr(tmpOrgUser) {
      this.$refs.confirm
        .open(
          "confirm",
          "기업참여 요청 대기자",
          tmpOrgUser.userName + "님의 요청을 취소 하시겠습니까?"
        )
        .then(() => {
          this.sendTmpUserInfo.tmpUserSequence = tmpOrgUser.id;
          this.sendTmpUserInfo.tmpOrgSequence = this.atvOrgInfo.organizationSequence;
          this.sendTmpUserInfo.approvalFlag = false;

          this.$refs.loading.start("입력 정보 확인 중");
          confirmOrgReqUser(this.sendTmpUserInfo).then(Response => {
            if (
              Response.rdata !== undefined &&
              Response.rdata.rcode === 20000
            ) {
              this.$refs.loading.end();
              this.$refs.confirm.open(
                "alert",
                "기업참여 요청 대기자",
                "승인 거부 완료"
              );
              this.getOrgList();
            } else {
              this.$refs.loading.end();
              var msg = "";
              if (Response.rdata === undefined) {
                msg = Response.message;
              } else {
                msg = Response.rdata.message;
              }
              this.$refs.confirm.open("alert", "기업참여 요청 대기자", msg);
            }
          });
        });
    },

    // 계약 담당자 삭제
    deleteUsr(orgusrlist) {
      if (this.orgUsrList.length > 1) {
        this.$refs.confirm
          .open(
            "confirm",
            "계약 담당자",
            "계약 담당자 " + orgusrlist.userName + "님을 삭제 하시겠습니까?"
          )
          .then(() => {
            this.sendDelUserInfo.tmpUserSequence = orgusrlist.id;
            this.sendDelUserInfo.tmpOrgSequence = this.atvOrgInfo.organizationSequence;

            this.$refs.loading.start("입력 정보 확인 중");
            removeOrgReqUser(this.sendDelUserInfo).then(Response => {
              if (
                Response.rdata !== undefined &&
                Response.rdata.rcode === 20000
              ) {
                this.$refs.loading.end();
                this.$refs.confirm.open(
                  "alert",
                  "계약 담당자",
                  "사용자 삭제가 완료되었습니다"
                );
                this.sendDelUserInfo.tmpUserSequence = 0;
                this.getOrgList();
              } else {
                this.$refs.loading.end();
                var msg = "";
                if (Response.rdata === undefined) {
                  msg = Response.message;
                } else {
                  msg = Response.rdata.message;
                }
                this.$refs.confirm.open("alert", "계약 담당자", msg);
              }
            });
          });
      } else {
        this.$refs.confirm.open(
          "alert",
          "기업탈퇴",
          orgusrlist.userName +
            "님은 기업의 마지막 사용자입니다. 마지막 사용자는 삭제 할 수 없습니다."
        );
      }
    },

    fnExcelDown() {
      window.location.href = process.env.VUE_APP_DOWNLOAD + "sawon";
    },

    // Excel 파일 Json 파싱
    readFile(event) {
      this.componentKey++;
      const file = event;

      const reader = new FileReader();
      const tmpResult = {};

      reader.onload = e => {
        var data = e.target.result;
        data = new Uint8Array(data);

        const excelFile = XLSX.read(data, { type: "array" });

        excelFile.SheetNames.forEach(function(sheetName) {
          const roa = XLSX.utils.sheet_to_json(excelFile.Sheets[sheetName], {
            header: ["이름", "아이디", "이메일"],
            range: 9,
            defval: ""
          });
          if (roa.length) tmpResult[sheetName] = roa;
        });
        this.excelUploadList = tmpResult.Sheet1;

        this.$refs.loading.start("입력 정보 확인 중");
        setSawonList({ excelUploadList: this.excelUploadList })
          .then(response => {
            this.excelUploadList = response.rdata.excelList;
            this.successUploadList = response.rdata.successList;
            this.successCnt = response.rdata.successCnt;
            this.resultCode = response.rdata.resultCode;

            this.excelUploadList.sort(function(a, b) {
              if (a.성공여부 === "N") return -1; // b가 a(실패)보다 뒤에 있어야 함.
              if (a.성공여부 === "Y") return 1; // b가 a(성공)보다 앞에 있어야 함.
              return 0;
            });

            this.$refs.loading.end();
          })
          .catch(() => {});
      };
      reader.readAsArrayBuffer(file);
    },

    // 엑셀 업로드
    fnExcelUpload() {
      this.$refs.loading.start("입력 정보 확인 중");
      setSawonExcelInsert({ successUploadList: this.successUploadList })
        .then(response => {
          this.$refs.loading.end();
          this.$refs.confirm.open(
            "alert",
            "엑셀 업로드",
            "등록이 완료 되었습니다"
          );
          this.excelUploadList = [];
          this.successUploadList = [];
          this.fileList = [];
          this.crewPop01 = false;
          this.getOrgList();
        })
        .catch(() => {});
    },

    // 취소함수
    fnCancel(msg) {
      this.$refs.confirm
        .open("confirm", msg, msg + "을 취소 하시겠습니까?")
        .then(() => {
          this.excelUploadList = [];
          this.successUploadList = [];
          this.fileList = [];
          if (msg === "개별 등록") {
            this.crewPop02 = false;
          } else if (msg === "엑셀 업로드") {
            this.crewPop01 = false;
          }
        });
    }
  }
};
</script>
<style>
.list_no_txt {
  padding: 20px 0;
  width: 100%;
  font-size: 0.8rem;
  color: #a4a5a9;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
}
.list_carD02_ulTxtBox li .txt_txt_rl {
  display: inline-block;
  margin-left: 20px;
  width: calc(100% - 120px);
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.7rem;
  color: #434846;
  vertical-align: middle;
}
@media (max-width: 640px) {
  .list_carD02_ulTxtBox li .txt_txt_rl {
    margin-left: 0;
    width: auto;
  }
}
</style>
